// NOTE: Needed to wrap scripts.js call with proper js convention since it's utilizing bigpipe
(function ($, Drupal, drupalSettings) {
	'use strict';
	Drupal.behaviors.nhra = {
		attach: function (context, settings) {

			// Header
			$('#header').lmHeader();
			$('#footer').lmFooter();

			// Gallery
			$('.gallery').lmGallery();
			$('.has-share-drop').lmShareDrop();
			$('.dropdown').lmDropdowns();
			$('.gallery-wrap').lmOnloadScroll();
			
			// Accordion Module
			$('.accordion').lmAccordion();

			// Schedule
			$('.print-button').lmPrint();

			// Event
			$('body[class*="path-schedule"]').lmOnloadScroll();

			// Events
			$('body[class*="page-node-type-event"]').lmOnloadScroll();

			// Image Grid Module
			$('.image-cards--grid').lmImageGrid();

			// Tabs Module
			$('.tab-nav').lmTabs();

			$('.results-rail').lmRailSlider();

			//modal
			$('.main').lmModal();

			// Tabs Module
			$('#homeTabs').lmTabs({
				panelWrapper: '.columns-wrapper--tabbed',
				panelActive: 'column--mobile-active',
				tabPanelItem: '.column'
			});

			// Tabs CTAS
			$('body[class*="page-node-type"] [href*="'+location.pathname+'#tab-"]').on('click', function(evt) {
				evt.preventDefault();
				var _tab = $(evt.currentTarget).attr('href').split('#tab-')[1];
				var $tab = $('[data-tab="'+_tab+'"]');
				var _scrollOffset = $('.tab-nav').offset().top - ($('.header').height() - $('.series-menu:visible').height());
				$('html, body').stop().animate({'scrollTop': _scrollOffset}, 500);
				$tab.trigger('click');
			});

			// Table Module
			$('.wysiwyg table, .table').lmTable();

			// Live Table Module
			$('#tableLive').lmLiveEvents();

			// Now Playing Module
			$('#featureVideo').lmNowPlaying();

			// Sponsor Slider
			$('.sponsor-slider').lmSponsorslider();

			// Detect if video autplay is supported and then apply a modifier
			$('.video-banner').lmDetectAutoplay();

			$('.driver-search').lmDriverSearch();

			// Generate Featured Video List
			$('[data-current-bcvid]').lmFeaturedVideos();

			// Track Locator
			$('.track-locator').lmTrackLocator();
			if('.nhra-track-locator'){
				$.getScript("//code.jquery.com/ui/1.13.2/jquery-ui.min.js");
			}
			$('.nhra-track-locator').nhraTrackLocator();

			// Home Content Toggle
			$('.content-switch').lmContentSwitch();

			// Media Form Validation
			$('#mediaForm').lmValidation();

			$('.article-list--event').lmEqualHeights();

			$('.image-cards').lmEqualHeights({
				selectors: ['.feature-heading'],
				$wrapper: $('.image-cards'),
				$tabWrapper: $('.tab-nav__item')
			});

			// Helper classes for mobile if page has title-bar-dropdowns
			var dropdownCount = $('.title-bar-dropdowns').find('.dropdown').length;
			
			if ( dropdownCount > 10 ) { dropdownCount = 10; };
			
			if( dropdownCount ) {
				$('.main').addClass('has-title-bar-dropdowns has-title-bar-dropdowns-' + dropdownCount);
			}

			// Video Block Player
			$('.video-player-block').nhraVideoBlockPlayer();

			// News
			$('body[class*="page-node-type-article"]').nhraNewsNav();

			// Run SVG4Everybody
			svg4everybody();
		
		}
	}
}(jQuery, Drupal, drupalSettings));
